import React from "react";
import { Radio as RadioMantine, RadioProps } from "@mantine/core";
import { HiCheck } from "react-icons/hi";

const Radio: React.FC<RadioProps> = (props) => {
  return <RadioMantine icon={HiCheck} {...props} />;
};

export default Radio;
